import React from 'react';
import FeedbackTab from '../components/FeedbackTab';

export default function Feedback() {
  return <FeedbackTab />;
}
